import * as React from 'react';
import { Redirect } from 'react-router-dom';
import * as Urls from 'Shared/Urls';

function renderFn(): React.ReactNode {
  return <Redirect to={Urls.edgeUrl()} />;
}

export default renderFn;
